import { Component, OnInit, Input, Output, EventEmitter, ChangeDetectionStrategy, HostBinding, Renderer2, ElementRef, } from '@angular/core';

@Component({
    selector: 'shared-square-image',
    templateUrl: './square-image.shared.component.html',
    styleUrls: ['./square-image.shared.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SquareImageComponent implements OnInit {
    private _isLoaded: boolean = false;

    @Input() public icon: boolean = false;
    @Input() public radius: string = '100%';
    @Input() public src: string;
    @Input() public alt: string = '';
    @Input() public loading: boolean = false;
    @Input() public invisible: boolean = false; /* Never show image - only loader */
    @Input() public imgBg: boolean = false;
    @Input() public imgWidth: string = null;

    @Output() public onLoaded: EventEmitter<Event> = new EventEmitter();

    @HostBinding('style.border-radius') public borderRadius: string = '100%';

    constructor(
        public elementRef: ElementRef,
        public renderer2: Renderer2,
    ) { }

    ngOnInit(): void {
        if (this.src && !this._isLoaded) {
            this.loading = true;
        }
        this.borderRadius = this.radius;

        if (this.icon) {
            this.renderer2.addClass(this.elementRef.nativeElement, '-icon');
        }

        if (!this.imgBg) {
            this.renderer2.addClass(this.elementRef.nativeElement, '-transparent');
        }
    }

    public handleOnLoaded($event: Event): void {
        this._isLoaded = true;
        this.loading = false;

        this.onLoaded.emit($event);
    }
}
